"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var AutoCompleteState_1 = require("../AutoComplete/AutoCompleteState");

var Chip_1 = __importDefault(require("../Chip/Chip"));

var withStyles_1 = require("../decorators/withStyles");

var Dropdown_1 = __importDefault(require("../Dropdown/Dropdown"));

var Input_1 = __importDefault(require("../Input/Input"));

var ContactsAutoComplete_styles_1 = require("./ContactsAutoComplete.styles");

var DropdownItem_1 = require("./DropdownItem"); // Нужно быть аккуратнее используя компонент в IE11 там есть баги с flex-wrap.
// Там ContactsAutoComplete должен быть вложен в контейнер с фиксированной
// шириной (это один из способов решить проблему, вроде бы как есть ещё)


var ContactsAutoComplete = function ContactsAutoComplete(_a) {
  var options = _a.options,
      classes = _a.classes,
      highlightWords = _a.highlightWords,
      value = _a.value,
      selected = _a.selected,
      onChange = _a.onChange,
      onDelete = _a.onDelete,
      onSelect = _a.onSelect,
      onEmailSelect = _a.onEmailSelect,
      dropdownOverlayContainer = _a.dropdownOverlayContainer,
      initPlaceholder = _a.placeholder,
      _b = _a.testIds,
      testIds = _b === void 0 ? {} : _b,
      forceOpen = _a.forceOpen;

  var _c = react_1.default.useState(initPlaceholder),
      placeholder = _c[0],
      changePlaceholder = _c[1];

  var _d = AutoCompleteState_1.useAutoCompleteState({
    value: value,
    selected: selected,
    options: options,
    onChange: onChange,
    onDelete: onDelete,
    onSelect: onSelect,
    onEmailSelect: onEmailSelect
  }),
      isChipsShown = _d.isChipsShown,
      dropdownProps = _d.dropdownProps,
      overlayProps = _d.overlayProps,
      _e = _d.containerProps,
      containerRef = _e.forwardRef,
      containerProps = __rest(_e, ["forwardRef"]),
      optionProps = _d.optionProps,
      _f = _d.inputProps,
      inputRef = _f.forwardRef,
      inputProps = __rest(_f, ["forwardRef"]),
      chipProps = _d.chipProps;

  var chipView = function chipView(option) {
    return react_1.default.createElement("div", {
      key: option.id,
      className: classes.chipWrapper
    }, react_1.default.createElement(Chip_1.default, {
      avatar: option.avatar,
      onCloseClick: function onCloseClick(e) {
        e.preventDefault();
        e.stopPropagation();
        chipProps(option).onDelete();
      },
      text: option.title,
      testId: "" + testIds.chipPrefix + (option.email || option.id)
    }));
  };

  return react_1.default.createElement(Dropdown_1.default, __assign({}, dropdownProps, {
    testId: testIds.dropdown,
    mode: "text",
    overlayContainer: dropdownOverlayContainer,
    open: forceOpen !== null && forceOpen !== void 0 ? forceOpen : dropdownProps.open,
    overlay: react_1.default.createElement("div", {
      className: classes.overlay,
      ref: overlayProps.forwardRef
    }, options.map(function (option) {
      return react_1.default.createElement(DropdownItem_1.DropdownItem, {
        testId: "" + testIds.dropdownItemPrefix + (option.email || option.id),
        onClick: function onClick() {
          changePlaceholder(initPlaceholder);
          optionProps(option).onClick();
        },
        key: option.id,
        option: option,
        onMouseOver: function onMouseOver() {
          changePlaceholder(option.title);
        },
        onMouseOut: function onMouseOut() {
          changePlaceholder(initPlaceholder);
        },
        highlightWords: highlightWords
      });
    }))
  }), react_1.default.createElement("div", __assign({}, containerProps, {
    ref: containerRef,
    onClick: function onClick() {
      containerProps.onClick();
    },
    className: classes.container
  }), isChipsShown && selected.map(chipView), react_1.default.createElement("div", {
    className: classes.inputWrapper
  }, react_1.default.createElement(Input_1.default, __assign({
    testId: testIds.input,
    placeholder: placeholder,
    inputRef: inputRef,
    type: "text",
    borders: "withoutBorders"
  }, inputProps)))));
};

exports.default = withStyles_1.withStyles(ContactsAutoComplete_styles_1.styles)(ContactsAutoComplete);